import script from "./LogPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LogPanel.vue?vue&type=script&setup=true&lang=js"

import "./LogPanel.vue?vue&type=style&index=0&id=0c81d51a&lang=scss"

const __exports__ = script;

export default __exports__